import { FC, useMemo, useState } from 'react';

import Tabs from '@shared/components/Tabs';
import { useSearchParams } from 'react-router-dom';

import GiftStoreFooter from '../components/GiftStoreFooter';

// 답례품 이용약관 (추후 실제 내용으로 교체)
const giftStoreTermsText = `답례품 서비스 이용약관

제1조 (목적)
본 약관은 가온프라임(이하 "회사")이 제공하는 답례품 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "서비스"란 회사가 제공하는 온라인 답례품 구매 및 교환 서비스를 말합니다.
2. "이용자"란 본 약관에 따라 서비스를 이용하는 자를 말합니다.
3. "답례품"이란 부고를 알린 상가에서 조문객에게 감사의 뜻으로 전달하는 선물을 말합니다.

제3조 (서비스 이용)
1. 서비스는 회원가입 없이도 이용 가능합니다.
2. 이용자는 본 약관에 동의한 것으로 간주됩니다.

제4조 (서비스 내용)
1. 답례품 상품 정보 제공
2. 답례품 구매 및 결제 서비스
3. 쿠폰형 답례품 교환 서비스
4. 주문 조회 및 관리 서비스

※ 본 약관은 추후 변경될 수 있으며, 변경 시 공지사항을 통해 안내드립니다.
`;

// 답례품 개인정보처리방침 (추후 실제 내용으로 교체)
const giftStorePrivacyText = `답례품 서비스 개인정보 처리방침

1. 개인정보의 처리 목적
가온프라임은 답례품 서비스 제공을 위해 최소한의 개인정보를 처리합니다.
- 서비스 이용에 따른 본인 확인
- 주문 및 배송 처리
- 고객 문의 응대

2. 처리하는 개인정보 항목
- 필수항목: 수령자 이름, 연락처, 배송지 주소
- 쿠폰형 답례품: 수령자 휴대폰 번호

3. 개인정보의 보유 및 이용기간
- 주문 정보: 관련 법령에 따라 5년간 보관
- 쿠폰 교환 정보: 쿠폰 유효기간 + 1년

4. 개인정보의 파기
보유기간이 경과한 개인정보는 지체 없이 파기합니다.

5. 이용자의 권리
이용자는 개인정보의 열람, 정정, 삭제, 처리정지를 요청할 수 있습니다.

6. 개인정보 보호책임자
- 이름: 김기훈
- 연락처: 1877-1954
- 이메일: smartnanumi@kakao.com

※ 본 방침은 추후 변경될 수 있으며, 변경 시 공지사항을 통해 안내드립니다.
`;

// 답례품 교환 및 환불 규정 (추후 실제 내용으로 교체)
const giftStoreRefundText = `답례품 교환 및 환불 규정

1. 쿠폰형 답례품
  - 유효기간: 구매일로부터 1년
  - 교환 신청 후 취소 불가
  - 미사용 쿠폰은 유효기간 내 환불 가능 (구매가의 90%)

2. 배송형 답례품
  - 주문 후 배송 전: 전액 환불 가능
  - 배송 완료 후: 상품 하자 시에만 교환/환불 가능

3. 환불 절차
  1) 고객센터 또는 마이페이지를 통해 환불 신청
  2) 환불 사유 확인 후 처리
  3) 결제 수단에 따라 3~7 영업일 내 환불

4. 환불 불가 사유
  - 이미 사용된 쿠폰
  - 유효기간이 경과한 쿠폰
  - 고객 귀책 사유로 인한 상품 훼손

5. 고객센터 안내
  - 전화: 1877-1954
  - 운영시간: 평일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)
  - 이메일: smartnanumi@kakao.com

※ 본 규정은 추후 변경될 수 있으며, 변경 시 공지사항을 통해 안내드립니다.
`;

export const GiftStoreTermsPage: FC = function GiftStoreTermsPage() {
  const [searchParams] = useSearchParams();
  const title = searchParams.get('title');

  const defaultTab = () => {
    switch (title) {
      case 'use':
        return 0;
      case 'privacy':
        return 1;
      case 'refund':
        return 2;
      default:
        return 0;
    }
  };

  const tabItems = ['이용약관', '개인정보 처리방침', '교환 및 환불규정'];
  const [selectedTab, setSelectedTab] = useState(defaultTab());

  const tabContent = useMemo(() => {
    switch (selectedTab) {
      case 0:
        return <div className="text-sm">{giftStoreTermsText}</div>;
      case 1:
        return <div className="text-sm">{giftStorePrivacyText}</div>;
      case 2:
        return <div className="text-sm">{giftStoreRefundText}</div>;
      default:
        return <div className="text-sm">{giftStoreTermsText}</div>;
    }
  }, [selectedTab]);

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="font-medium">
        <div className="space-y-2 md:space-y-4">
          <div className="p-4">
            <Tabs
              items={tabItems}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              className="bg-none"
            />
            <div className="mt-4 h-[calc(100vh-220px)] overflow-y-scroll whitespace-pre-line rounded-lg border bg-white p-4">
              {tabContent}
            </div>
          </div>
          <GiftStoreFooter />
        </div>
      </section>
    </div>
  );
};

export default GiftStoreTermsPage;
